<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="text"
          :label="label"
          :rules="rules"
          :disabled="disabled"
          dense
          clearable
          hide-details
          placeholder="TT.MM.JJJJ"
          v-bind="attrs"
          @click:clear="clear"
          @blur="commitText"
          @keydown.enter.prevent="commitText"
          @mousedown.prevent="openMenu"
          @click="openMenu"
        >
          <!-- keep the icon as the menu activator: looks best -->
          <template v-slot:prepend>
            <v-icon v-on="on">event</v-icon>
          </template>
        </v-text-field>
      </template>

      <date-picker
        show-weeknumbers
        locale="de-DE"
        is24hr
        v-model="pickerVal"
        @input="menu = false"
        :attributes="attrsCalendar"
      />
    </v-menu>

    <div class="error--text caption mt-1" v-if="parseError">
      {{ parseError }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["value", "label", "disabled", "rules"],

  data: () => ({
    menu: false,
    text: "",
    parseError: null,
    attrsCalendar: [
      {
        key: "today",
        highlight: { color: "blue", fillMode: "light" },
        dates: new Date(),
      },
    ],
  }),

  computed: {
    pickerVal: {
      get() {
        const d = this.toDate(this.value);
        return d ? this.toISODate(d) : "";
      },
      set(val) {
        const d = this.toDate(val) || this.fromISODate(val);
        if (!d) return;

        this.parseError = null;
        this.text = this.formatDateObjDE(d);
        this.$emit("input", this.atLocalMidnight(d));
      },
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(v) {
        const d = this.toDate(v);
        if (!d) {
          this.text = "";
          this.parseError = null;
          return;
        }
        this.text = this.formatDateObjDE(d);
      },
    },
  },

  methods: {
    openMenu() {
      if (!this.disabled) this.menu = true;
    },

    clear() {
      this.parseError = null;
      this.text = "";
      this.$emit("input", null);
    },

    commitText() {
      const raw = (this.text || "").trim();
      if (!raw) return this.clear();

      const d = this.parseDE(raw);
      if (!d) {
        this.parseError = this.$t("general.invalidDate");
        return;
      }

      this.parseError = null;
      this.text = this.formatDateObjDE(d);
      this.$emit("input", this.atLocalMidnight(d));
    },

    toDate(v) {
      if (!v) return null;
      if (v instanceof Date) return isNaN(v.getTime()) ? null : v;
      const d = new Date(v);
      return isNaN(d.getTime()) ? null : d;
    },

    fromISODate(s) {
      if (typeof s !== "string") return null;
      const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!m) return null;
      const y = +m[1],
        mo = +m[2],
        da = +m[3];
      const d = new Date(y, mo - 1, da);
      return isNaN(d.getTime()) ? null : d;
    },

    toISODate(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const da = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${da}`;
    },

    atLocalMidnight(d) {
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    },

    parseDE(s) {
      const cleaned = s.replace(/\s+/g, "").replace(/[/-]/g, ".");
      const m = cleaned.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
      if (!m) return null;

      const dd = parseInt(m[1], 10);
      const mm = parseInt(m[2], 10);
      const yyyy = parseInt(m[3], 10);

      const d = new Date(yyyy, mm - 1, dd);
      if (
        d.getFullYear() !== yyyy ||
        d.getMonth() !== mm - 1 ||
        d.getDate() !== dd
      ) {
        return null;
      }
      return d;
    },

    formatDateObjDE(d) {
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();
      return `${dd}.${mm}.${yyyy}`;
    },
  },
};
</script>
